import { useLayoutEffect } from "react";
import { WSO2_LOGOUT_URL } from "../../constants/API";
import { RouteComponentProps, withRouter } from "react-router";

function LoginFailed(props: RouteComponentProps) {
  useLayoutEffect(() => {
    const param = props.location.search;
    if (param && param.includes("error")) {
      let error = param.replace("?error=", "");
      error = error.replace(/%20/g, " ");
      localStorage.setItem("ws02error", error);
      window.location.href = WSO2_LOGOUT_URL;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export default withRouter(LoginFailed);
